<template>
    <div class="vqb-group card" :class="'depth-' + depth.toString()">
        <div class="vqb-group-heading card-header">
            <div class="d-flex align-center mb-1">
                <label class="pt-1 mr-2">
                    {{ labels.matchType }}
                </label>

                <v-select
                    v-model="query.logicalOperator"
                    :items="labels.matchTypes"
                    item-text="label"
                    item-value="id"
                    style="max-width: 90px"
                    class="pt-0"
                    dense
                    single-line
                    hide-details
                >
                </v-select>

                <v-spacer></v-spacer>

                <button
                    v-if="depth > 1"
                    type="button"
                    class="close"
                    @click="remove"
                    v-html="labels.removeGroup"
                ></button>
            </div>
        </div>

        <div class="vqb-group-body card-body">
            <div class="rule-actions form-inline">
                <div class="form-group d-flex align-center">
                    <label class="pt-1 mr-7">
                        {{ labels.field }}
                    </label>

                    <v-select
                        v-model="selectedRule"
                        :items="rules"
                        item-text="label"
                        item-value="id"
                        style="max-width: 175px"
                        class="pt-0 mr-2"
                        dense
                        return-object
                        single-line
                        hide-details
                    >
                    </v-select>

                    <v-spacer></v-spacer>

                    <v-btn
                        @click="addRule"
                        class="mr-2 btn-bg-color-dark-blue white--text"
                        style="padding-top: 3px"
                        x-small
                    >
                        {{ labels.addRule }}
                    </v-btn>

                    <v-btn
                        v-if="depth < maxDepth"
                        @click="addGroup"
                        class="btn-bg-color-dark-blue white--text"
                        style="padding-top: 3px"
                        x-small
                    >
                        {{ labels.addGroup }}
                    </v-btn>
                </div>
            </div>

            <query-builder-children v-bind="$props" />
        </div>
    </div>
</template>

<script>
import QueryBuilderGroup from "vue-query-builder/dist/group/QueryBuilderGroup.umd";
import QueryBuilderRule from "./QueryBuilderRule";

export default {
    components: {
        QueryBuilderRule: QueryBuilderRule,
    },
    extends: QueryBuilderGroup,
};
</script>

<style>
.vue-query-builder .vqb-group .rule-actions {
    margin-bottom: 20px;
}

.vue-query-builder .vqb-rule {
    margin-top: 15px !important;
    margin-bottom: 15px !important;
    border-color: #ddd;
    padding: 25px 15px !important;
}

.vqb-group.depth-2 {
    margin-top: 15px;
    margin-bottom: 15px;
    border-color: #ddd;
    padding: 10px 15px;
}

.vue-query-builder .vqb-group.depth-1 .vqb-rule,
.vue-query-builder .vqb-group.depth-2 {
    border-left: 2px solid #8bc34a;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    background-color: #f5f5f5;
}

.vue-query-builder .vqb-group.depth-2 .vqb-rule,
.vue-query-builder .vqb-group.depth-3 {
    border-left: 2px solid #00bcd4;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    background-color: white;
}

.vue-query-builder .vqb-group.depth-3 .vqb-rule,
.vue-query-builder .vqb-group.depth-4 {
    border-left: 2px solid #ff5722;
}

.vue-query-builder .close {
    opacity: 1;
    color: rgb(150, 150, 150);
}

@media (min-width: 768px) {
    .vue-query-builder .vqb-rule.form-inline .form-group {
        display: block;
    }
}
</style>
